module.exports = __webpack_public_path__ + "img/closed-loop-10.f89885eb.png";